var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-2"},[_c('div',{staticClass:"pb-12 mb-10 border-b border-gray-500"},[_c('shared-with-me',{attrs:{"broker":_vm.broker,"shared_with_me":_vm.shared_with_me}})],1),_vm._v(" "),_c('div',{staticClass:"pb-8"},[_c('shared-with-others',{attrs:{"broker":_vm.broker,"shared_with_others":_vm.shared_with_others}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }